// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"page-footer_footerContainer__UgVvH","footerInfoContainer":"page-footer_footerInfoContainer__2rIxF"};